export default {
  "common-try-slogin": "连接全球人与应用",
  "common-button-立即试用": "立即试用",
  "common-consult": "方案咨询",
  "common-consult-descript": "获取更多信息，请联系我们的销售和技术支持团队。",
  "common-customer": "了解 Authing，帮助你实现快速增长",
  "common-more": "了解更多",
  "common-story": "了解故事",
  "input-placeholder": "输入手机号立即开始",
  // "try-on": "免费使用",
  "try-on": "免费体验",
  "check-fun": "查看功能",
  "common-company": "蒸汽记忆（北京）信息科技有限公司 ",
  "timeline-title": "更新日志",
  "timeline-slogan": "我们在持续进行功能和体验升级",
  "timeline-publish": "最新版",
  "down-solution": "下载解决方案",
  "how-use": "如何使用",
  check: "点击图片查看",
  nav: {
    "nav-docs": "https://docs.authing.cn/",
    "nav-home": "首页",
    "nav-ROI": "ROI 计算器",
    "nav-demo": "体验 Demo",
    "nav-product": "产品与服务",
    "nav-solution": "解决方案",
    "nav-resource": "资源中心",
    "nav-case": "成功案例",
    "nav-timeline": "更新日志",
    "nav-cloud-native": "云原生",
    "nav-solution-medical": "医疗",
    "nav-solution-government": "政府",
    "nav-solution-education": "教育",
    "nav-solution-finance": "金融",
    "nav-solution-cars": "汽车",
    "nav-solution-energy": "能源",
    "nav-solution-enterprise": "企业服务",
    "nav-solution-game": "游戏",
    "nav-solution-software": "科技",
    "nav-solution-manufacture": "先进制造",
    "nav-solution-publisher": "出版",
    "nav-solution-consume": "新消费",
    "nav-solution-wechat": "全场景微信登录解决方案",
    "nav-solution-idaas": "全面替代 IAM",
    "nav-solution-okta": "全面替代 Okta",
    "nav-solution-auth0": "全面替代 Auth0",
    "nav-solution-ad": "增强微软 AD 身份方案",
    "nav-solution-cognito": "全面替代 AWS Cognito",
    "nav-solution-keycloak": "Keycloak VS Authing",
    "nav-solution-private-cloud": "私有部署身份云",
    "nav-solution-mfa": "自适应 MFA",
    "nav-solution-build-idaas": "构建企业专属的身份云",
    "nav-solution-identity": "不同身份源的用户信息同步及更新",
    "nav-solution-zero-trust": "为组织构建零信任网络",
    "nav-solution-digital-identity": "为公民建设数字身份",
    "nav-developer": "开发者",

    "nav-developer-center": "开发者中心",
    "nav-developer-center-descript": "在这里找到和 Authing 开发相关的内容",
    "nav-developer-community": "开发者论坛",
    "nav-developer-community-descript": "与 Authing 的工程师和用户在线交流",
    "nav-developer-document": "开发者文档",
    "nav-developer-document-descript": "帮助你快速上手 Authing",
    "nav-developer-blog": "博客",
    "nav-price": "价格",
    "nav-abuoutus": "关于 Authing",
    "nav-company-intro": "公司介绍",
    "nav-customer": "客户故事",
    "nav-customer-success": "客户成功服务",
    "nav-marketplace": "合作网络",
    "nav-console": "控制台",
    "nav-personal": "个人中心",
    "nav-login": "登录/注册",
    "nav-mobile-login": "立即登录",
    "nav-logout": "退出",
    "nav-type-customer": "客户故事",
    "nav-customer-hep": "高等教育出版社",
    "nav-customer-cocacola": "可口可乐",
    "nav-customer-cnpn": "中国石油",
    "nav-customer-futu": "富途牛牛",
    "nav-customer-southeast-university": "东南大学",
    "nav-customer-xian-gong": "仙工智能",
    "nav-customer-yuanqi": "元气森林",
    "nav-customer-nreal": "Nreal",
    "nav-customer-volkswagen": "大众汽车",
    "nav-customer-jcdecaux": "JCDecaux",
    "nav-case-description":
      "互联网创业公司、独角兽和世界 500 强企业都在使用 Authing 授权、集成和管理他们的员工和用户。",
    "nav-resource-whitepaper": "白皮书",
    "nav-resource-whitepaper-descript": "感受集成 Authing 的便利性",
    "nav-resource-demo": "体验 Demo",
    "nav-resource-demo-descript": "感受 Authing 控制台的高效交互性",
    "nav-type-application": "我们的优势",
    "nav-type-company": "公司介绍",
    "nav-type-about": "关于我们",
    "nav-type-news": "快讯连接",
    "nav-type-APN": "合作网络",
    "nav-type-APN-img":
      "//files.authing.co/authing-website/nav-about-img-apn.png",
    "nav-about-financing": "融资信息",
    "nav-about-news": "重大新闻",
    "nav-type-product": "我们的产品",
    "nav-type-service": "安全与服务",
    "nav-product-extra-title": "产品优势",
    "nav-type-industry": "行业领域",
    "nav-type-staff": "员工身份",
    "nav-type-user": "用户身份",
    "nav-type-extend": "扩展功能",
    "nav-extend-database": "连接自定义数据库",
    "nav-extend-pipeline": "身份工作流 Pipeline",
    "nav-extend-operate": "IDaaS 运营平台",
    "nav-extend-maintenance": "IDaaS 运维平台",
    "nav-extend-radius": "网络认证（Radius）",
    "nav-type-scense": "场景解决方案",
    "nav-solution-extra-title": "微信生态解决方案",
    "nav-solution-extra-subtitle":
      "Authing 作为优秀的身份管理解决方案提供商，无论在 B2B，B2C，B2E 或 IoT 场景，都会为企业带来显著的竞争优势：降低开发成本、提高安全性、助力生产效率。",
    "nav-type-developer": "相关资源介绍",
    "nav-type-developer-social": "开发者社区",
    "nav-type-developer-resource": "开发者资源",
    "nav-developer-api": "开放 API 门户",
    "nav-developer-api-descript": "助你获取 Authing 能力",
    "nav-developer-doclink": "常用文档",
    "nav-developer-extra-oidc": "使用 OIDC",
    "nav-developer-extra-mfa": "移动安全 MFA",
    "nav-about-extra-title": "了解 Authing",
    "nav-developer-extra-start": "快速开始",
    "nav-developer-extra-start-subtitle": "为你的应用轻松集成身份系统",
    "nav-developer-extra-pipeline": "自定义认证流程",
    "nav-developer-extra-pipeline-subtitle": "根据你的需求灵活配置认证流程",
    "nav-developer-extra-pipeline-img-default":
      "//files.authing.co/authing-website/nav-developer-pipeline-v2.png",
    "nav-developer-extra-pipeline-img":
      "//files.authing.co/authing-website/nav-developer-pipeline-default-v2.png",
    "nav-developer-extra-start-img-default":
      "//files.authing.co/authing-website/nav-developer-getstart-default-v2.png",
    "nav-developer-extra-start-img":
      "//files.authing.co/authing-website/nav-developer-getstart-v2.png",
    "nav-developer-blog-descript": "在 Authing 博客上关注最新动态",
    "nav-tag-joinus": "正在招募",
    "learn-more": "查看更多",
    "nav-overview": "总览",
    "news-blog1": "Authing Share｜密码：安全领域的基石",
    "news-blog2": "继 Facebook 后领英再爆 5 亿数据泄露，用户关键信息统统流出",
    "news-blog3": "Theragun 如何用 Authing 为百万用户统一登录体验",
    "nav-developer-api-user": "认证 API",
    "nav-developer-api-user-des": "用户登录、注册",
    "nav-developer-api-manage": "管理 API",
    "nav-developer-api-manage-des": "管理你的用户和组织机构",
  },
  footer: {
    "footer-product": "产品介绍",
    "footer-product-advance": "产品优势",
    "footer-platform": "开放平台",
    "footer-support-doc": "开发者文档",
    "footer-platform-api": "Open API",
    "footer-platform-resource": "开发资源",
    "footer-platform-problem": "常见问题",
    "footer-platform-example": "集成案例",
    "footer-solution": "解决方案",
    "footer-support": "技术支持",
    "footer-doc": "开发者文档",
    "footer-friendly-link": "友情链接",
    "footer-support-community": "开发者论坛",
    "footer-support-Github": "GitHub",
    "footer-support-blog": "技术博客",
    "footer-company": "公司信息",
    "footer-company-joinus": "加入我们",
    "footer-company-phone": "400 888 2106",
    "footer-company-email": "sales@authing.com",
    "footer-network": "合作伙伴体系",
    "company-address-name": "北京地址（总）",
    "branch-address-name": "成都地址（分）",
    "shanghai-address-name": "上海地址（分）",
    "wuhan-address-name": "武汉地址（分）",
    "beijing-company-address": "北京市朝阳区北辰世纪中心 B 座 16 层",
    "chengdu-company-address":
      "成都市高新区天府五街 200 号 1 号楼 B 区 4 楼 406 室",
    "shanghai-company-address": "上海市杨浦区政民路 300 号",
    "wuhan-company-address":
      "武汉市东湖新技术开发区关山大道保利国际中心 7 楼氪空间",
    "shenzhen-company-address":
      "深圳市南山科苑路讯美科技广场 3 号楼 14 层 A10 室",
    "mobile-total-company-address": "北京市朝阳区北辰世纪中心 B 座 16 层（总）",
    "mobile-branch-company-address":
      "成都市高新区天府五街 200 号 1 号楼 B 区 4 楼 406 室（分）",
    "mobile-shanghai-company-address":
      "深圳市南山科苑路讯美科技广场 3 号楼 14 层 A10 室 (分)",
    "mobile-shenzhen-company-address": "上海市杨浦区政民路 300 号 (分)",
    "mobile-wuhan-company-address":
      "武汉市东湖新技术开发区关山大道保利国际中心 7 楼氪空间（分）",

    "footer-privacy-policy": "隐私条款",
    "footer-service-agreement": "服务协议",
    "footer-language": "语言 - Language",
    "footer-adress": "京ICP备19051205号-7",
    "footer-beian": "京公网安备 11010802035968号",
    "footer-copyright": "© 北京蒸汽记忆科技有限公司",
    "footer-sitemap": "网站地图",
    "footer-okta": "OKTA",
    "footer-solution-wechat": "微信登录解决方案",
    "footer-solution-cognito": "全面替代 Cognito",
    "footer-juzi": "句子互动",
    "footer-mingdao": "明道云零代码",
    "footer-hengshi": "衡石科技",
    "footer-kalacloud": "卡拉云",
    "footer-mingque": "明雀",
    "footer-apiseven-link": "https://www.apiseven.com/zh",
    "footer-gitlab": "极狐",
    "footer-gitlab-link": "https://about.gitlab.cn",
    "footer-merico": "思码逸",
    "footer-fbmms": "方便面招聘",
    "footer-dragontest": "龙测科技",
    extendAdress: "北京市朝阳区北辰西路 8 号院 4 号楼",
    "footer-pay-news": "付费资讯",
    "city-title": "全国 5 个城市",
    beijing: "北京（总部）",
    shanghai: "上海",
    shenzhen: "深圳",
    chengdu: "成都",
    wuhan: "武汉",
  },
  common: {
    "product-identity": "身份自动化",
    "product-sso": "单点登录 SSO",
    "product-mfa": "自适应多因素认证",
    "product-comp": "通用登录组件",
    "product-verify": "手机号码闪验",
    "product-security": "安全与合规",
    "product-database": "自定义数据库连接",
    "product-authorization": "授权",
    "product-api": "API 访问管理（M2M）",
    "product-user-management": "用户管理",
    "product-user-directory": "用户目录",
    "product-life-cycle": "生命周期管理",
    "product-gateway": "应用集成网关",
    "product-gateway-integration": "应用集成网关",
    "product-authority": "权限管理",
    "product-tenant": "多租户管理",
  },
  button: {
    "try-now": "立即使用",
    "trial-request": "申请试用",
    "try-now-roi": "立即计算 ROI",
    "buy-now": "立即购买",
    "see-more": "查看更多",
    "learn-more": "查看详情",
    "develop-consult": "开发咨询",
    "develop-community": "开发文档",
    "contact-us": "联系我们",
    "quick-start": "快速开始",
    "wait-consult": "等待联系",
    consult: "预约咨询",
    linkDoc: "查看文档",
    "check-now": "立即查看",
    "check-case": "查看案例",
    expect: "敬请期待",
    detail: "了解详情",
    community: "加入社区",
    review: "年度回顾",
  },
  form: {
    name: "姓名",
    phone: "电话",
    company: "公司",
    other: "备注",
    submit: "立即提交",
    cancel: "取消",
    // "contact-form-title": "注册你的信息，我们会在 15 分钟内安排专家联系你",
    "contact-form-title": "获得企业级解决方案",
    "contact-subtitle":
      "Authing 已向超过 28 个行业输出了实践方案，我们很乐意与你所在的企业分享经验，并提供免费演示方案。",
    "success-tip": "你已经提交成功！",
    "success-down-tip": "提交成功！点击按钮即可下载",
    "success-wait-tip": "专家正在赶来的路上...",
    "success-try-tip": "需求着急，请打 400 888 2106，将有专人立即服务",
    "name-placeholder": "希望我们怎么称呼你？",
    "phone-placeholder": "我们的顾问将尽快致电你",
    "company-placeholder": "请填写你的公司信息",
    position: "职位",
    "position-placeholder": "请填写你的职位信息",
    "contact-name": "名字",
    "contact-way": "手机",
    "contact-title": "获得企业级解决方案",
    "contact-tip": "你也可以通过微信或手机和我们的销售人员直接联系",
    "apply-title": "提交你的申请",
    "apply-name": "真实姓名",
    "apply-email": "电子邮箱",
    "apply-type": "投递类型",
    "apply-position": "投递岗位",
    "apply-method": "简历投递方式",
    "mail-address": "邮箱地址",
    "mail-address-info": "简历请投递",
    "mail-title": "邮件标题：姓名 + 岗位名称",
    "mail-content": "投递内容：邮件内容 + 附件简历",
    otherTip: "你是否想与客服代表联系？",
    otherTip1: "请致电",
    otherTip2: "联系我们",
  },
  formPage: {
    subtitle: "高速增长的企业 ",
    title: "都把身份交给 Authing",
    name: "姓名",
    company: "企业全称",
    position: "职务",
    phone: "联系电话",
    scene: "应用场景（多选）",
    industry: "所属行业",
    finance: "金融",
    energy: "能源",
    car: "汽车",
    manufacture: "制造业",
    food: "餐饮",
    retail: "新消费",
    server: "企业服务",
    meta: "元宇宙",
    game: "游戏",
    consult: "咨询服务",
    estate: "地产",
    media: "传媒",
    educate: "教育",
    medical: "医疗制药",
    other: "其他",
    remark: "备注",
    b2b: "我想为我的 B 端客户提供更好的身份认证体验",
    b2c: "我想为我的 C 端用户提供更好的身份认证体验",
    b2e: "我想为企业员工管理身份",
  },
  // startedFree: "免费领取方案",
  startedFree: "立即计算 ROI",
  // formNotice: "如何打造身份体系，解决企业管理及开发效率难题？",
  formNotice:
    "基于 4W+ 企业和开发者数据，为你量身计算，构建身份体系的投入产出比!",
  // notice: "Authing 新版本已于 2020-09-17 发布，性能突飞猛进。咨询电话：176-0250-2507",
  notice:
    "Authing 正在参加 HW 行动，时间为 10 个工作日，你可以正常使用 Authing 产品，你的员工和已上线的业务都不受任何影响。请转向 www.authing.co 继续访问官网。咨询电话：19816542466 或 17602502507",
  linkDoc: "查看文档",
  about: {
    title: "关于 Authing",
    description1:
      "Authing 是一款以开发者为中心的全场景身份云产品，集成了所有主流身份认证协议，为企业和开发者提供完善安全的用户认证和访问管理服务。",
    description2:
      "Authing 被科技部认定为「2020 国家高新技术企业」，被中国信息通信研究院评选为「国内身份管理与访问控制领域创新企业」，并被录入《2019 网络安全产业白皮书》。2021 年 8 月，Authing 入选福布斯亚洲的「最值得关注公司」百强榜单。2021 年 9 月，Authing 顺利入选中国信息通信研究院「卓信大数据计划」的第三批成员单位。Authing 已为中国石油、国家电网、招商银行、日本丰田、德高集团等国内外优秀企业打造了卓越的开发方式、高效的办公流程和安全的 IT 管理体系。",
    qrcodePublic: "「Authing 身份云」公众号",
    qrcodeBusiness: "商务合作",
  },
  logo: {
    中国石油: "中国石油",
    国家电网: "国家电网",
    丰田: "丰田",
    招商银行: "招商银行",
    高等教育出版社: "高等教育出版社",
    东南大学: "东南大学",
    华西医院: "华西医院",
    德高集团: "德高集团",
    云测: "云测",
    盼达用车: "盼达用车",
    THERAGUN: "THERAGUN",
    宾利: "宾利",
    stackchat: "Stackchat",
    chatopera: "Chatopera",
    腾讯云: "腾讯云",
    亚马逊: "亚马逊",
    乐智机器人: "乐智机器人",
    文因互联: "文因互联",
    金蝶: "金蝶",
    freeCodeCamp: "freeCodeCamp",
    阿里云: "阿里云",
    句子互动: "句子互动",
    华为云: "华为云",
    金证优智: "金证优智",
    一清创新: "一清创新",
  },

  pageLink: {
    title: "你可能还想了解",
    sso: {
      title: "单点登录 SSO",
      description:
        "单点登录 SSO 是整合企业系统的解决方案之一，旨在多个应用系统中，用户只需要登录一次就可以访...",
    },
    mfa: {
      title: "自适应多因素认证",
      description:
        "自适应多因素认证 MFA 是一种简单有效的安全实践方法，它能够在用户名和密码之外再额外增加一层...",
    },
    comp: {
      title: "通用登录组件",
      description:
        "登录组件（Guard) 帮助开发者屏蔽了很多底层认证的实现细节，同时也包括繁琐的 UI 开发...",
    },
    verify: {
      title: "手机号码闪验",
      description:
        "依托于微信官网的实名用户信息，用户一键授权即可以真实号码完成注册/登录，为开发者建立以手机...",
    },
    database: {
      title: "自定义数据库连接",
      description:
        "当你想保障数据安全性或平滑迁移用户时，请使用 Authing 自定义数据库连接，既能连接自己维护的...",
    },
    iam: {
      title: "全面替代 IAM",
      description:
        "随着企业数字转型和上云进度的加速，企业信息安全的维度和边界正在变得越来越复杂，身份认证和访问...",
    },
    okta: {
      title: "全面替代 Okta",
      description:
        "我们通过身份中台、工作流、目录、应用集成、用户分析、开发组件六个维度与 Okta 进行对比可...",
    },
    wechat: {
      title: "微信生态解决方案",
      description:
        "Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理，为你的顾客和员工提供最完善的登录...",
    },
    keycloak: {
      title: "Keycloak VS Authing",
      description:
        "Keycloak 是一个开源软件产品，旨在为现代的应用程序和服务，提供包含身份管理和访问管理功能的...",
    },
    buildIdaas: {
      title: "构建企业专属的身份云",
      description:
        "随着企业逐渐加快数字化转型，「身份和访问管理」对于企业成功至关重要。完善的身份和访问管理解决...",
    },
    finance: {
      title: "金融行业解决方案",
      description:
        "深耕银行、保险、证券基金企业，对内统一身份认证体系、增强安全风控，对外提升金融...",
    },
    manufacture: {
      title: "先进制造解决方案",
      description:
        "深耕芯片、机器人、航空航天、医药医械等先进制造行业，为企业搭建高生产力、高安全、高性能的...",
    },
    ad: {
      title: "增强微软 AD 方案",
      description:
        "过去，企业依赖 AD 用于验证资源访问，如今已不足够。现在，你需要更灵活的身份增...",
    },
    price: {
      title: "价格",
      description:
        "你只需为活跃用户付费。Authing 已帮助上千家企业和开发者构建标准化的用...",
    },
    tech: {
      title: "科技行业解决方案",
      description:
        "统一应用矩阵的登录与认证体系，让科技产品拥有科技感的身份管理。",
    },
  },
  chatrobot: {
    scan: "扫一扫获取",
    privateService: "专员服务",
    support1: "添加企业微信",
    support2: "“一对一”解答产品问题",
    online: "在线咨询",
    wecom: "添加企微",
    token: "下载令牌",
    ceoEmail: "CEO 邮箱",
    phone: "电话咨询",
    onlineTip1: "如何打造完善的身份体系？",
    onlineTip2: "身份顾问在线解答",
    wecomTip: "添加企业微信，领取行业资料",
    tokenTip: "下载 Authing 令牌，体验快速登录认证！",
    ceoEmailTip: "产品或服务问题？直接反馈给 CEO",
    phoneTip: "电话联系专家，更高效！",
    freeUse: "免费使用",
    alreadyCopy: "已复制",
  },
  "quotation-consultation": "报价咨询",
  "chat-online": "在线咨询",
  "chat-phone": "电话咨询",
  "tool-package": {
    title: "媒体工具包",
    subtitle: "提供各种格式的资源供媒体们进行使用",
    toolTip: {
      title: "想要下载我们的 LOGO ？",
      downMediaKit: "下载 LOGO 压缩包",
      viewMediaKit: "查看媒体工具包",
    },
  },
  news: {
    title: "付费资讯",
    "pay-button": "付费 ¥9.9 购买",
    news1: {
      title: "Authing 宣布推出云原生「多租户」身份解决方案",
      text: `Authing 是以开发者为中心，基于云原生架构的 IDaaS 产品，是一个独立的、中立的、可伸缩、安全的云身份管理基础设施，支持所有企业和开发者便捷灵活接入，满足各类场景化需求。 
近期，Authing 宣布为企业客户推出「多租户」场景下的身份认证与授权解决方案，旨在帮助 SaaS 行业客户快速上线复杂的「多租户」管理能力，同时助力其为合作伙伴提供更佳的身份管理全旅程体验。`,
    },
    news2: {
      title: "当谈论卖 SaaS 时，我们究竟在卖什么？",
      text: `10 月 24 日，身份云平台 Authing 宣布完成 2300 万美元 A 轮融资。本轮融资由老虎环球基金领投，鼎晖VGC（创新与成长基金）、声网 Agora、老股东 GGV纪源资本和奇绩创坛跟投，跃为资本担任独家财务顾问。11 月 19 日下午，A 轮融资记者招待会成功举办，行业多方知名媒体参与。Authing 创始人谢扬发表“ 当谈论卖 SaaS，我们究竟在卖什么？”主题演讲，下面是本次演讲的精彩回顾。`,
    },
    news3: {
      title: "Spring Security 集成 CAS 项目编码 认证（三）",
      text: `在上一篇文章（《CAS 在 Authing 控制台配置 认证（二）》）中，我们讲述了如何在 Authing 平台配置项目集成中需要的 CAS 的配置，以及在后期开发过程中如何获取配置。同时，也提前让大家预习和熟悉了一些项目搭建和编码过程中需要的知识点。接下来这一小节，就让我们一起来顺利完成项目搭建和编码过程吧。`,
    },
    news4: {
      title: "制造业身份认证统一管理解决方案",
      text: `中国制造业的转型，迫在眉睫，关乎存亡。
面对困境，就要寻求改变。多年来，中国制造业一直处于经济高速发展的快车道中，受益于不断开拓的“增量”市场。但在经济增长平稳化、外贸波动的今天，如何利用数字化、信息化技术改造制造业，让制造业突破“存量”市场带来的“内卷化”困境，正成为当前每一家深耕于制造业的企业探寻的方向。`,
    },
  },
};
